import React, { useState, useEffect } from 'react';
import './Hero.css';

const Hero: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  
  const carouselSlides = [
    {
      question: "Can your students solve real industry problems?",
      bullets: [
        "Build end-to-end AI solutions",
        "Debug complex algorithms", 
        "Deploy production-ready models"
      ]
    },
    {
      question: "Can they work confidently with modern AI tools and cloud platforms?",
      bullets: [
        "Master Python, TensorFlow, PyTorch",
        "Navigate AWS, Azure, Google Cloud",
        "Use MLOps and DevOps workflows"
      ]
    },
    {
      question: "Can they clear interviews and perform in their first year of employment?",
      bullets: [
        "Demonstrate portfolio projects",
        "Solve technical challenges",
        "Contribute from day one"
      ]
    }
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselSlides.length);
    }, 4000); // Change slide every 4 seconds

    return () => clearInterval(interval);
  }, [carouselSlides.length]);

  // Removed unused handleButtonClick function since CTA buttons were removed

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          {/* Eyebrow */}
          <div className="hero-eyebrow">
            <span className="eyebrow-text">FOR COLLEGES & UNIVERSITIES</span>
          </div>
          
          {/* Main Headline - Current Design */}
          <h1 className="hero-headline">
            <span className="headline-full">Transforming Classroom Students into Industry‑Ready AI Professionals — Without Disrupting Academics</span>
            <span className="headline-mobile">From Classroom to Career-Ready AI Professionals</span>
          </h1>

          {/* Alternative Headline Options (uncomment to use):
          
          Option 1: With highlighted keywords
          <h1 className="hero-headline">
            Transforming Classroom Students into <span className="highlight">Industry‑Ready AI Professionals</span> — Without Disrupting Academics
          </h1>

          Option 2: Split into emphasis parts
          <h1 className="hero-headline">
            <span className="primary">Transforming Classroom Students</span><br />
            <span className="secondary">into Industry‑Ready AI Professionals</span><br />
            <span className="tertiary">— Without Disrupting Academics</span>
          </h1>

          Option 3: With strong emphasis
          <h1 className="hero-headline">
            Transforming Classroom Students into <strong>Industry‑Ready AI Professionals</strong> — Without Disrupting Academics
          </h1>

          */}
          


          {/* Proof Bar */}
          <div className="proof-bar">
            <div className="proof-point">
              <span className="proof-icon">✓</span>
              <span>Trusted by 7,000+ students and professionals across India</span>
            </div>
            <div className="proof-point">
              <span className="proof-icon">✓</span>
              <span>Designed by industry AI practitioners</span>
            </div>
            <div className="proof-point">
              <span className="proof-icon">✓</span>
              <span>Outcome‑focused, portfolio‑ready projects</span>
            </div>
          </div>

          {/* Supporting Line - Moved Up */}
          <p className="supporting-line">
            Our pilot AI training program bridges the gap between academic knowledge and industry readiness for B.Tech and MCA students.
          </p>

          {/* Mobile CTA Button */}
          <div className="mobile-cta">
            <button 
              className="btn-mobile-pilot"
              onClick={() => {
                // Navigate to pilot program page
                window.location.href = '/pilot-program';
              }}
            >
              Start Pilot Program
            </button>
          </div>
        </div>

        {/* Right Side Content */}
        <div className="hero-right-content">
          {/* Central Gradient Card with Carousel */}
          <div className="gradient-card">
            <div className="carousel-container">
              {carouselSlides.map((slide, index) => (
                <div 
                  key={index}
                  className={`carousel-slide ${index === currentSlide ? 'active' : ''}`}
                >
                  <div className="slide-question">{slide.question}</div>
                  <ul className="slide-bullets">
                    {slide.bullets.map((bullet, bulletIndex) => (
                      <li key={bulletIndex} className="slide-bullet">
                        {bullet}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="carousel-dots">
              {carouselSlides.map((_, index) => (
                <div 
                  key={index}
                  className={`carousel-dot ${index === currentSlide ? 'active' : ''}`}
                  onClick={() => setCurrentSlide(index)}
                />
              ))}
            </div>
          </div>

          {/* Image */}
          <div className="hero-image-container">
            <img 
              src="/images/ai-classroom-training.jpg.png" 
              alt="Students learning AI and machine learning in a modern classroom with instructor teaching AI concepts"
              className="hero-image"
              onError={(e) => {
                // Fallback to placeholder if image doesn't exist
                const target = e.target as HTMLImageElement;
                target.style.display = 'none';
                const fallback = target.nextElementSibling as HTMLElement;
                if (fallback) fallback.style.display = 'flex';
              }}
            />
            {/* Fallback placeholder */}
            <div className="illustration-placeholder" style={{ display: 'none' }}>
              <div className="students-illustration">
                <div className="laptop-screen">
                  <div className="code-lines">
                    <div className="code-line"></div>
                    <div className="code-line short"></div>
                    <div className="code-line"></div>
                    <div className="code-line medium"></div>
                  </div>
                </div>
                <div className="ai-diagrams">
                  <div className="diagram-node"></div>
                  <div className="diagram-node"></div>
                  <div className="diagram-node"></div>
                  <div className="connection-line"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;